export default {
  rankOrder: {
    ariaAddOption: '{label} öğesini sıralı listeye ekle',
    ariaMoveUp: '{label} öğesini yukarı taşı',
    ariaMoveDown: '{label} öğesini aşağı taşı',
    ariaRemoveOption: '{label} öğesini sıralı listeden kaldır',
  },
  coe: {
    ariaDisclaimer: 'Uyarı',
    ariaQuestion: 'Soru',
    ariaConversationHistory: 'Konuşma geçmişi',
    ariaYourResponse: 'Cevabınız {number}',
    ariaFollowUpQuestion: 'Takip sorusu {number}',
    ariaResponseInput: 'Cevap alanı',
    ariaRespondingTo: 'Yanıtlanıyor',
    ariaSendResponse: 'Cevap gönder',
    ariaThinking: 'Düşünüyor'
  },
  deviceView: {
    toolbar: 'Önizleme cihazı',
    mobile: 'Mobil',
    tablet: 'Tablet',
    desktop: 'Masaüstü'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'QuestDIY logosu'
  }
}
